import { createTheme } from '@mui/material/styles';

import { DENTOLO_THEME } from '../theme';
import colors from '../tokens/colors';

import baseTheme from './base.theme';

const theme = createTheme(baseTheme, {
  name: DENTOLO_THEME,
  palette: {
    background: {
      primary: colors.ULTRA_CLEAR_LIGHT_BLUE,
      accordion: {
        header: colors.WHITE,
        body: colors.WHITE,
        footer: colors.WHITE,
      },
      button: colors.PROFESSIONAL_BLUE,
      input: colors.WHITE,
      modalOverlay: colors.PRODUCT_BLUE,
      pageHeaderTitle: colors.VITALIZED_GREEN,
      selectOption: colors.WHITE,
    },
    text: {
      primary: colors.PROFESSIONAL_BLUE,
      secondary: colors.PROFESSIONAL_LIGHT_BLUE,
      accent: colors.VITALIZED_GREEN,
      button: colors.VITALIZED_GREEN,
      checkbox: colors.PROFESSIONAL_BLUE,
      input: colors.PROFESSIONAL_BLUE,
      label: colors.PROFESSIONAL_BLUE,
      placeholder: colors.PRODUCT_BLUE,
    },
  },
  shadows: [
    baseTheme.shadows[0],
    baseTheme.shadows[1],
    'none',
    'none',
    'none',
    baseTheme.shadows[5],
    baseTheme.shadows[6],
    baseTheme.shadows[7],
  ],
});

export default theme;
